module.exports = __webpack_public_path__ + "img/main-new~03.09.2025.503196de.jpg";